// https://github.com/varun-raj/medium-editor-autolist
import MediumEditor from 'medium-editor'

var AutoList = MediumEditor.Extension.extend({
  name: 'autolist',
  init: function () {
    this.subscribe('editableKeypress', this.onKeypress.bind(this))
  },
  onKeypress: function (keyPressEvent) {
    if (
      MediumEditor.util.isKey(keyPressEvent, [MediumEditor.util.keyCode.SPACE])
    ) {
      var listStart = this.base.getSelectedParentElement().textContent
      if (listStart === '1.' && this.base.getExtensionByName('orderedlist')) {
        this.base.execAction('insertorderedlist')
        this.base.getSelectedParentElement().textContent = this.base
          .getSelectedParentElement()
          .textContent.slice(2)
          .trim()
      } else if (
        listStart === '*' &&
        this.base.getExtensionByName('unorderedlist')
      ) {
        console.log(' LIST START')
        this.base.execAction('insertunorderedlist')
        this.base.getSelectedParentElement().textContent = this.base
          .getSelectedParentElement()
          .textContent.slice(1)
          .trim()
      }
    }
  },
})

export default AutoList
